<template>
  <v-col cols="12">
    <BaseBlock title="Information ENSAP" v-if="messageInformation">
      <div v-html="messageInformation.message"></div>
    </BaseBlock>
  </v-col>
</template>

<script>
import ApiRefMessageRepository from "@/repositories/ApiRefMessageRepository";
import BaseBlock from "@/components/base/BaseBlock";
export default {
  components: {
    BaseBlock,
  },
  data() {
    return {
      messageInformation: null,
    };
  },
  async created() {
    this.messageInformation = await ApiRefMessageRepository.getByType(
      "INFORMATION_ENSAP"
    );
  },
};
</script>
